module.exports = __webpack_public_path__ + "9e04960e9cf7a86c68303f2757bbad52.pdf";